// @ts-nocheck
/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gb2_are_you_sure_you_want_to_delete_team__name__1 = /** @type {(inputs: { name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete team ${i?.name}?`)
};

const en_us2_are_you_sure_you_want_to_delete_team__name__1 = /** @type {(inputs: { name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete team ${i?.name}?`)
};

const de_de2_are_you_sure_you_want_to_delete_team__name__1 = /** @type {(inputs: { name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sind Sie sicher, dass Sie das Team ${i?.name} löschen möchten?`)
};

const en_are_you_sure_you_want_to_delete_team__name__1 = /** @type {(inputs: { name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete team ${i?.name}?`)
};

const de_are_you_sure_you_want_to_delete_team__name__1 = /** @type {(inputs: { name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sind Sie sicher, dass Sie das Team ${i?.name} löschen möchten?`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ name: NonNullable<unknown> }} inputs
* @param {{ locale?: "en-GB" | "en-US" | "de-DE" | "en" | "de" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const are_you_sure_you_want_to_delete_team__name__1 = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.are_you_sure_you_want_to_delete_team__name__1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("are_you_sure_you_want_to_delete_team__name__1", locale)
	if (locale === "en-GB") return en_gb2_are_you_sure_you_want_to_delete_team__name__1(inputs)
	if (locale === "en-US") return en_us2_are_you_sure_you_want_to_delete_team__name__1(inputs)
	if (locale === "de-DE") return de_de2_are_you_sure_you_want_to_delete_team__name__1(inputs)
	if (locale === "en") return en_are_you_sure_you_want_to_delete_team__name__1(inputs)
	return de_are_you_sure_you_want_to_delete_team__name__1(inputs)
};
export { are_you_sure_you_want_to_delete_team__name__1 as "Are you sure you want to delete team {name}?" }